import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			minWidth: 300,
			minHeight: '15rem',
			width: '95%',
			margin: '0 auto',
		},
		menuHeaderBackground: {
			background: '#FFE6D9',
			height: '192.56px',
			width: '100%',
		},
		menuHeaderImage: {
			margin: '-10rem auto 2rem',
			display: 'flex',
			justifyContent: 'center',
		},
		type: {
			fontSize: '24px',
			color: 'rgba(53, 56, 63, 1)',
			padding: '0 1rem',
			marginBottom: '1rem'
		},
		description: {
			position: 'relative',
			padding: 0,
			fontSize: '18px',
			color: 'rgba(120, 57, 61, 1)',
			margin: '0',
		},
		elements: {
			position: 'relative',
		},
		image: {
			position: 'relative',
			// height: '15rem',
			height:'400px !important',
			borderRadius: '1rem',
			zIndex: 1,
		},
		centerDIv: { 
			position: 'absolute', 
			left: '50%', 
			top: '70%',
			width: '95%', 
			transform: 'translate(-50%, -50%)',
			[theme.breakpoints.down('xs')]: {
				top: '99% !important',
			},
	 },
		listItems: { listStyleType: 'none' , paddingLeft:'0rem !important' },
		imageSrc: {
			position: 'absolute',
			width: '100%',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			backgroundSize: 'cover',
			backgroundPosition: 'center 40%',
			borderRadius: '1rem',
			zIndex: -1,
		},
		mobileBackground: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			marginLeft: '.5%',
			textAlign: 'center'
		},
	}),
);
